import { apiGet } from '../api'

export const get_home = () => {
  return apiGet({
    endpoint: 'home'
  })
}
